import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import { TextInput } from '../Helpers/Inputs';
import { InputMaskPhone } from '../Helpers/Formatters';
import BackNextButton from '../Common/BackNextButton';
import TitleComponent from '../Common/TitleComponent';
import { customValidators } from '../Helpers/Validators/customValidators';

export default function AgentInformation(props) {

    const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
        validationSchema: AgentInformation.ValidationSchema(props.isTerm),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
        triggerValidation(field);
    };

    useEffect(() => {
        // manually register fields for validation that don't play nice with react-hook-form register
        register({ name: 'firstName' });
        setValue('firstName', props.formState.firstName);

        register({ name: 'lastName' });
        setValue('lastName', props.formState.lastName);

        register({ name: 'email' });
        setValue('email', props.formState.email);

        register({ name: 'phone' });
        setValue('phone', props.formState.phone);

    }, [register]);

    return (
        <Container fluid className='border-class'>
            <form onSubmit={handleSubmit(props.submitRequest)}>
                <Row className="justify-content-center pt-4">
                    <Col lg={4} className="pt-3">
                        <TitleComponent title="Submit as" />
                        <Form.Group>
                            <TextInput
                                name="firstName"
                                id="firstName"
                                label="First Name"
                                value={props.formState.firstName}
                                onChange={e => handleValueChange('firstName', e.target.value)}
                                errors={errors && errors.firstName}
                                inputRef={register}
                            />
                        </Form.Group>
                        <Form.Group>

                            <TextInput
                                name="lastName"
                                id="lastName"
                                label="Last Name"
                                value={props.formState.lastName}
                                onChange={e => handleValueChange('lastName', e.target.value)}
                                errors={errors && errors.lastName}
                                inputRef={register}
                            />
                        </Form.Group>

                        <Form.Group>
                            <TextInput
                                name="email"
                                id="email"
                                label="Email Address"
                                value={props.formState.email}
                                onChange={e => handleValueChange('email', e.target.value)}
                                errors={errors && errors.email}
                                inputRef={register}
                            />
                        </Form.Group>

                        <Form.Group>
                            <TextInput
                                name="phone"
                                id="phone"
                                label="Phone"
                                value={props.formState.phone}
                                onChange={(e) => handleValueChange('phone', e.target.value)}
                                errors={errors.phone}
                                inputRef={register}
                                InputProps={{
                                    inputComponent: InputMaskPhone,
                                }}
                            />
                        </Form.Group>
                        {
                            props.error !== "" &&
                            <Row className='justify-content-center mb-3 px-5'>
                                <div className='errorMessageCustom'>{props.error}</div>
                            </Row>
                        }

                    </Col>
                </Row>
                <BackNextButton onBack={props.onBack} continueLabel='SUBMIT' isLoading={props.loading} disabled={props.loading} />
            </form>
        </Container>
    )
}

AgentInformation.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
};

AgentInformation.ValidationSchema = (isTerm) => {
    return (
        object().shape({
            firstName: customValidators.string()
                .isValidNameLimitedSpecialChar("First Name is required.", true, false),
            lastName: customValidators.string()
                .isValidNameLimitedSpecialChar("Last Name is required.", true, false),
            phone: string().required("Phone is required.").matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, 'Invalid Phone Number (10 digits only)'),
            email: string().email('Email address must be valid').required("Email address is required."),
        })
    )
}

AgentInformation.DefaultFormState = (prefill = false) => {
    return {
        phone: prefill ? '1234567898' : '',
        email: prefill ? 'user@address.com' : '',
        firstName: prefill ? 'Drew' : '',
        lastName: prefill ? 'Bernard' : '',
    }
};




// WEBPACK FOOTER //
// ./src/components/PolicyReview/AgentInformation.js